import { Box, Skeleton, Stack } from "@mui/material";

const TrimesterTabsSkeleton = () => {
  return (
    <Box
      p={2}
      sx={{
        maxWidth: "990px",
        margin: {
          xs: "0 auto",
          md: "0",
        },
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        mb={4}
      >
        {[70, 130, 150, 150, 110].map((width, index) => (
          <Skeleton
            key={index}
            variant="rectangular"
            width={width}
            height={36}
            sx={{ borderRadius: "18px" }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default TrimesterTabsSkeleton;
